import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

const createTag = async (tagData) => {
  try {
    const res = await API.create_tag(tagData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const updateTag = async (tagID, tagData) => {
  try {
    const res = await API.update_tag(tagID, tagData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const tagDetails = async (tagID) => {
  try {
    const res = await API.tag_details(tagID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getTagList = async (
  pageNum,
  filters,
  searchString,
  pageSize,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.tag_list(
      pageNum,
      filters,
      searchString,
      pageSize,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export { createTag, updateTag, tagDetails, getTagList };
